<template>
	<div class="mien">
		<p>
			<i class="el-icon-s-home"></i>
			<span @click="$router.replace('/')">网站首页</span>/ 会员中心/ 会员风采
		</p>
		<ul>
			<li v-for="(item, index) in list" :key="index" >
				<span @click="$router.replace({ path: 'meberDetail', query: { id: item.id } })">{{item.name}}</span>
				<el-divider></el-divider>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [
					{
						id: 1,
						name: '广东省南方文化产权交易所',
					},
					{
						id: 2,
						name: '苏州浩辰软件股份有限公司Gstarsoft Co'
					},
					{
						id: 3,
						name: '小聪软件产业'
					},
					{
						id: 4,
						name: '中望公司'
					}
				]
			};
		},
		mounted() {},
		methods: {},
	};
</script>
<style>
	.mien .el-divider--horizontal {
		margin: 10px 0;
	} 
</style>
<style scoped>
	.mien>p {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}

	.mien>p i {
		margin-right: 10px;
	}

	.mien>p span:hover {
		color: #016fb8;
		cursor: pointer;
	}
	.mien ul {
		margin-top: 10px;
	}
	
	.mien ul li {
		color: gray;
		font-size: 15px;
	}
	
	.mien ul li span:hover {
		color: #016fb8;
		border-bottom: 1px solid #016fb8;
		cursor: pointer
	}
		
</style>
